import PortfolioDealsEmptyState from './PortfolioDealsEmptyState.component';

export default PortfolioDealsEmptyState;
